import type { Dict } from "../core.js";
import type { bankPartners as vi } from "../vi/bankPartners.js";

export const bankPartners: Dict<typeof vi> = {
  hooksTitle: "Inbound by partner",
  hooksIntro: "Each partner has its own path and its own kind of key. Rejected deliveries are counted by reason (bad / missing key, stale timestamp) — a spike means the partner portal has the wrong key or someone is hammering the endpoint.",
  window24: "24 hours",
  window168: "7 days",
  partner: "Partner",
  paths: "Path",
  accepted: "Accepted",
  rejected: "Rejected",
  lastAccepted: "Last accepted",
  lastRejected: "Last rejected {at}",
  noAdapter: "no adapter yet",
  none: "—",
  billingTitle: "Suspensions & billing drift",
  billingIntro: "Connections suspended by Bube, and connections whose stop / resume billing command at the partner is not done or cannot be done automatically (paused at Bube while the partner may still charge).",
  billingEmpty: "Nothing to handle.",
  connection: "Connection",
  workspace: "Company",
  status: "Status",
  billingState: "Partner billing",
  suspension: "Suspension",
  "state.pending": "telling the partner",
  "state.failed": "failed — retrying",
  "state.unsupported": "not automatic — handle manually",
  "state.done": "done",
  "state.not_needed": "not needed",
  "desired.stopped": "stop",
  "desired.running": "run",
  "reason.unpaid": "Unpaid",
  "reason.service": "Service stopped",
  "reason.fraud": "Suspected fraud",
  reasonHint: "Unpaid / service stopped ⇒ stops at the partner. Suspected fraud ⇒ the partner keeps sending (kept as evidence), nothing is delivered to the customer.",
  suspendTitle: "Suspend a connection",
  connectionId: "Connection ID (pcn_…)",
  reason: "Reason",
  note: "Note (optional)",
  suspend: "Suspend",
  lift: "Lift suspension",
  confirmLift: "Lift the suspension of {id}? The connection returns to its status before the suspension.",
  done: "Saved.",
  auditTitle: "Tingee VAs ⇄ connections",
  auditIntro: "Calls Tingee for REAL with the Live key (read only). Leave Merchant ID empty ⇒ bube-banktransfer finds it (the merchant list if the key may read it, otherwise the last 10 days of transactions).",
  merchantId: "Merchant ID",
  merchantIdAuto: "empty = find automatically",
  merchantIdInvalid: "Merchant ID must be a positive integer.",
  merchantsUsed: "Merchants scanned: {ids}",
  "source.given": "entered by hand",
  "source.merchant_api": "found via Tingee's merchant list",
  "source.transactions": "found via the last 10 days of transactions",
  runAudit: "Compare",
  running: "Comparing…",
  scanned: "{n} VAs scanned at Tingee",
  truncated: "Scan limit reached — « missing at Tingee » is not conclusive.",
  orphan: "Orphan VAs at Tingee (no Bube connection — may still be charged)",
  missing: "Bube connections receiving while Tingee no longer has the VA",
  mismatch: "Status mismatch (Tingee not active, Bube active)",
  clean: "Everything matches.",
  loadFailed: "Could not read bube-banktransfer.",
  failed: "Could not complete.",
};
